const RELOADED_FLAG = 'plentify:preload-error-reloaded'

export function registerPreloadErrorReload(
  storage: Pick<Storage, 'getItem' | 'setItem'> = sessionStorage,
  location: Pick<Location, 'reload'> = window.location
): void {
  window.addEventListener('vite:preloadError', (event) => {
    // Only auto-reload once per session; after that, let the error propagate.
    if (storage.getItem(RELOADED_FLAG)) return

    event.preventDefault()
    storage.setItem(RELOADED_FLAG, '1')
    location.reload()
  })
}
